export const getTaskActionConfirmationDescription = buttonLabel =>
  `Do you want to proceed with the following action: ${buttonLabel}?`;
